var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useSearchParams } from 'react-router-dom';
import { has } from 'lodash';
import Footer from "../../../App/Footer";
import { searchParamsFromSearchParams } from "../../../utils/routeHelpers";
import { t } from "../../../I18N";
import { handledErrors } from "../../shared/errorUtils";
import { ErrorFallback } from "./ErrorFallback";

const GeneralError = () => {
  const { errorCode } = useParams();
  const [searchParams] = useSearchParams();

  const { requestId } = searchParamsFromSearchParams(searchParams);
  const { status } =
  errorCode && has(handledErrors, errorCode) ? handledErrors[errorCode] : handledErrors[404];
  const safeRequestId = /^[0-9-]{4}$/.exec(requestId);
  const error = handledErrors[status];
  error.requestId = safeRequestId ? safeRequestId[0] : undefined;

  error.name = t('System', error.name, null, false);

  return (/*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Helmet, {}, void 0, /*#__PURE__*/
    _jsx("title", {}, void 0, error.name)
    ), /*#__PURE__*/
    _jsx(ErrorFallback, { error: error }), /*#__PURE__*/
    _jsx(Footer, {})
    ));

};

export { GeneralError };